module.exports = "<div class=\"message\">\r\n  <mat-icon>{{ icon }}</mat-icon>\r\n  {{ message }}\r\n</div>\r\n<button mat-icon-button (click)=\"close()\">\r\n  <mat-icon>close</mat-icon>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/notify/notify.component.html
// module id = ./libs/atenea-cms/src/notify/notify.component.html
// module chunks = main